/**
 @author xiaoye
 @date 2020/4/22 4:01 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

//获取数据库表的字段类型
let token01 = null;
export const CreateNewScreen = async (data) => {
    if (token01) {
        token01.cancel({status: 'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/CreateNewScreen?" + qs.stringify(data),
        method: "get",
        token: token01.token,
    })
};

//依据分辨率获取模板信息
let token02 = null;
export const GetModelIDBySize = async (data) => {
    if (token02) {
        token02.cancel({status: 'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/GetModelIDBySize?" + qs.stringify(data),
        method: "get",
        token: token02.token,
    })
};

//获取同一用户下是否有相同名称的大屏
let token03 = null;
export const GetScreenNameVerify = async (data) => {
    if (token03) {
        token03.cancel({status: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/GetScreenNameVerify?" + qs.stringify(data),
        method: "get",
        token: token03.token,
    })
};
